import { useData } from '@apps/context';
import { IconButton, Stack, Typography } from '@mui/material';
import CompareCarIcon from '@stack/assets/icons/compare-car.svg';
import { useGetResponsive } from '@stack/helpers/lib/responsive';
import { Swiper } from '@stack/ui';
import { size } from 'lodash';

import CarKeyDetailBox from '../../CarKeyDetail';
import { SpecAndFeatureDataType, SpecAndFeatureProps } from '..';

/**
 * ===========================
 * MAIN
 * ===========================
 */
export const SpecAndFeatureMobileView: React.FC<SpecAndFeatureProps> = (
  props
) => {
  const { data } = props;
  const { isMobile } = useGetResponsive();
  const { addId, ids, removeId } = useData();

  // console.log('compare', ids);

  // ======================= VIEWS  const renderSpec = ({
  const RenderSpec = (item: SpecAndFeatureDataType & { index: number }) => {
    const { id, model, price = 0, monthly = 0, index } = item;

    const onClickCompare = (e: { stopPropagation: () => void }) => {
      e?.stopPropagation();
      addId(id?.toString());
    };

    const onRemoveCompare = (e: { stopPropagation: () => void }) => {
      e?.stopPropagation();
      removeId(id?.toString());
    };

    const isLimited = size(ids) > 3;
    const isAdded = ids?.includes(id?.toString());
    const disabled = isLimited && !isAdded;

    return (
      <Stack key={id} sx={{ pb: 12 }}>
        <Stack
          sx={{
            border: '1px solid #EDECED',
            flexDirection: 'row',
            display: 'flex',
            paddingY: '1rem',
            paddingX: '1rem',
            justifyContent: 'space-between',
            transition: 'background-color 0.2s ease-in',
            background: 'white',
            alignItems: 'center',
          }}
        >
          <Stack gap={2} width={'100%'}>
            <Typography
              color="#1E242F"
              fontWeight={500}
              overflow={'hidden'}
              textOverflow={'ellipsis'}
              whiteSpace="nowrap"
              fontSize={'0.875rem'}
              textAlign="left"
            >
              {model}
            </Typography>
            <Stack
              flexDirection="row"
              gap={4}
              // justifyContent={'space-between'}
              alignItems={'center'}
              width={'100%'}
            >
              <Stack flexDirection="column" width={'70%'}>
                <Stack flexDirection="row" gap={4}>
                  <Typography
                    color="#1E242F"
                    fontWeight={400}
                    fontSize={'0.875rem'}
                    textAlign="left"
                    width={'40%'}
                  >
                    Car Price
                  </Typography>
                  <Typography
                    color="#1E242F"
                    fontWeight={500}
                    fontSize={'0.875rem'}
                  >
                    {Number(price) === 0
                      ? 'TBC'
                      : `RM${' '}
                    ${Intl.NumberFormat('en-us')
                      .format(Math.round(Number(price)))
                      .toLocaleString()}`}
                  </Typography>
                </Stack>

                <Stack flexDirection="row" gap={4}>
                  <Typography
                    color="#1E242F"
                    fontWeight={400}
                    fontSize={'0.875rem'}
                    width={'40%'}
                    textAlign="left"
                  >
                    Monthly
                  </Typography>
                  <Typography
                    color="#1E242F"
                    fontWeight={500}
                    fontSize={'0.875rem'}
                  >
                    {Number(monthly) === 0
                      ? 'X'
                      : `RM${' '}
                    ${Intl.NumberFormat('en-us')
                      .format(Math.round(Number(monthly)))
                      .toLocaleString()}`}
                  </Typography>
                </Stack>
              </Stack>
              <Stack>
                <IconButton
                  disabled={disabled}
                  onClick={isAdded ? onRemoveCompare : onClickCompare}
                  sx={{
                    backgroundColor: isAdded ? '#D6DEEA' : '#1E242F',
                    height: 35,
                    width: 35,
                    padding: 0,
                    '&:hover': {
                      backgroundColor: isAdded ? '#D6DEEA' : '#1E242F',
                    },
                    '&.Mui-disabled': {
                      color: 'text.primary',
                      cursor: 'default',
                      backgroundColor: '#1E242F',
                      opacity: 0.5,
                    },
                  }}
                >
                  {isAdded ? <CompareCarIcon /> : <CompareCarIcon />}
                </IconButton>
              </Stack>
            </Stack>
          </Stack>
        </Stack>
        <Stack
          style={{
            overflow: 'hidden',
            // height: isAdded ? 600 : 0,
            transition: 'all 0.3s ease-out',
          }}
        >
          <CarKeyDetailBox
            data={data[index]}
            showHeader={false}
            containerProps={{ borderTop: 'none' }}
          />
        </Stack>
      </Stack>
    );
  };

  return (
    <Swiper
      list={data}
      navigation={true}
      isSliderButtonCentered
      allowTouchMove
      navigationProps={{
        sx: {
          top: '35px',
          boxShadow: 'none',
          height: '32px',
          width: '32px',
          background: '#E9ECF3',
          '&:hover': {
            background: '#E9ECF3',
            boxShadow: 'none',
          },
        },
      }}
      renderSlide={(car, index) => (
        <RenderSpec {...car} index={index} key={index} />
      )}
      spaceBetween={12}
      slidesPerView={{
        mobile: 1,
      }}
      height={isMobile ? 'auto' : '570px'}
    />
  );
};

/**
 * ===========================
 * EXPORTS
 * ===========================
 */
export default SpecAndFeatureMobileView;
